// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__90WSD","headerbar":"Header_headerbar__dsoOV"};